<template>
    <left-stripe-layout
        class="d-flex flex-column justify-center" 
        :color="announcement.color"
    >
        <Header 
            class="header"
            :large="false" 
            :two-line="false"
            :color="announcement.color"
            :icon="announcement.iconName"
            :text="displayShort && announcement.shortTitle ? announcement.shortTitle : announcement.title"
        ></Header>
        <div class="announcement-content">
            <p class="announcement-text" v-if="lessonPlan.length === 0">Litujeme, aktuálně nejsou dostupná žádná data o&nbsp;nadcházející výuce...</p>
            <div v-else>
                <table v-if="isLandscape" class="table">
                    <tr v-for="n in Math.ceil(lessonPlan.length/2)" :key="`lesson-${n}`">
                        <td :class="lessonPlan[n-1].isSeminar === false && 'important-cell'">
                            {{lessonPlan[n-1].courseCode}}
                        </td>
                        <td class="center-column">
                            {{lessonPlan[n-1].room}}
                        </td>
                        <td class="time-column"> 
                            {{lessonPlan[n-1].startTime}}
                        </td>
                        <td class="divider"></td>
                        <td v-if="n === 1" class="divider-line" :rowspan="Math.ceil(lessonPlan.length/2)"></td>
                        <td class="divider"></td>
                        <td :class="lessonPlan[Math.ceil(lessonPlan.length/2) + n - 1].isSeminar === false && 'important-cell'">
                            {{lessonPlan[Math.ceil(lessonPlan.length/2) + n - 1] ?  lessonPlan[Math.ceil(lessonPlan.length/2) + n - 1].courseCode : ''}}
                        </td>
                        <td class="center-column">
                            {{lessonPlan[Math.ceil(lessonPlan.length/2) + n - 1] ? lessonPlan[Math.ceil(lessonPlan.length/2) + n - 1].room : ''}}
                        </td>
                        <td class="time-column">
                            {{lessonPlan[Math.ceil(lessonPlan.length/2) + n - 1] ? lessonPlan[Math.ceil(lessonPlan.length/2) + n - 1].startTime : ''}}
                        </td>
                    </tr>
                </table>
                <table v-else class="portrait-table">
                    <tr v-for="n in Math.min(lessonPlan.length, 10)" :key="`lesson-${n}`">
                        <td :class="lessonPlan[n].isSeminar === false && 'important-cell'">
                            {{lessonPlan[n].courseCode}}
                        </td>
                        <td class="center-column">
                            {{lessonPlan[n].room}}
                        </td>
                        <td class="time-column">
                            {{lessonPlan[n].startTime}}
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </left-stripe-layout>
</template>

<script>
import Header from '../../../components/Header';
import LeftStripeLayout from './Layouts/LeftStripeLayout.vue';

export default {
    name: "LessonPlanService",

    props: {
        announcement: Object,
        isLandscape: Boolean,
        isParallel: Boolean,
        isPreview: Boolean,
    },

    data() {
        return {
            previewData: [
                { room: "Q05", endTime: "08:50", startTime: "07:00", typeName: "cvičení", courseName: "Úvod do ICT", isSeminar: true, courseCode: "EBC-UICT" },
                { room: "Q07", endTime: "08:50", startTime: "07:00", typeName: "cvičení", courseName: "Algoritmizace", isSeminar: true, courseCode: "ALG" },
                { room: "Q08", endTime: "08:50", startTime: "07:00", typeName: "cvičení", courseName: "Základy objektového návrhu", isSeminar: true, courseCode: "EBC-ZOO" },
                { room: "Q14", endTime: "08:50", startTime: "07:00", typeName: "cvičení", courseName: "Diplomní seminář IS/ICT", isSeminar: true, courseCode: "DISI" },
                { room: "Q15", endTime: "08:50", startTime: "07:00", typeName: "cvičení", courseName: "Teoretické základy informatiky", isSeminar: true, courseCode: "EBC-TZI" },
                { room: "Q21", endTime: "08:50", startTime: "07:00", typeName: "cvičení", courseName: "Angličtina 1, EI", isSeminar: true, courseCode: "JE1" },
                { room: "Q22", endTime: "08:50", startTime: "07:00", typeName: "cvičení", courseName: "Mikroekonomie 1", isSeminar: true, courseCode: "EBC-MI" },
                { room: "Q23", endTime: "08:50", startTime: "07:00", typeName: "cvičení", courseName: "Finanční účetnictví 1", isSeminar: true, courseCode: "EBC-FU" },
                { room: "Q27", endTime: "08:50", startTime: "07:00", typeName: "cvičení", courseName: "Marketing II", isSeminar: true, courseCode: "MVY" },
                { room: "Q33", endTime: "08:50", startTime: "07:00", typeName: "cvičení", courseName: "Akademické dovednosti", isSeminar: true, courseCode: "EBC-AKD" },
                { room: "Q01", endTime: "10:50", startTime: "09:00", typeName: "přednáška", courseName: "Mezinárodní marketing", isSeminar: false, courseCode: "MFM" },
                { room: "Q05", endTime: "11:50", startTime: "09:00", typeName: "cvičení", courseName: "Moderní informační technologie", isSeminar: true, courseCode: "EBC-MIT" },
                { room: "Q06", endTime: "11:50", startTime: "09:00", typeName: "cvičení", courseName: "Informační systémy (projektování)", isSeminar: true, courseCode: "ISP" },
                { room: "Q07", endTime: "10:50", startTime: "09:00", typeName: "cvičení", courseName: "Algoritmizace", isSeminar: true, courseCode: "ALG" },
                { room: "Q08", endTime: "10:50", startTime: "09:00", typeName: "přednáška", courseName: "Programovací jazyk Perl", isSeminar: false, courseCode: "EBC-PRL" },
                { room: "Q09", endTime: "10:50", startTime: "09:00", typeName: "cvičení", courseName: "Úvod do ICT", isSeminar: true, courseCode: "EBC-UICT" }
            ]
        }
    },
    
    computed: {
        lessonPlan() {
            return (this.isPreview ? this.previewData : JSON.parse(this.announcement.text)).slice(0, this.isParallel && this.isLandscape ? 10 : 16)
        },

        displayShort() {
            return this.isParallel && this.isLandscape;
        },
    },

    components: {
        Header,
        LeftStripeLayout,
    }
}
</script>

<style scoped>
    .announcement {
        background: black;
        color: white;
        overflow: hidden;
        font-family: 'Roadgeek';
    }

    .announcement-text {
        font-size: 1.7vw;
    }

    .single .announcement-text {
        font-size: 2vw;
    }

    .single .header {
        margin-top: 3%;
        margin-bottom: 2%;
    }

    .announcement-content {
        width: 100%;
        height: 100%;
        display: flex;
        flex-flow: row;
        justify-content: space-between;
    }

    .announcement-content > div {
        width: 100%;
        height: 100%;
    }

    .table {
        width: 100%;
        height: 97%;
        font-size: 2vw;
        text-align: left;
    }

    .parallel .table {
        font-size: 1.4vw;
    }

    .portrait-table {
        width: 100%;
        height: 97%;
        font-size: 2vw;
        text-align: left;
    }

    .divider {
        width: 2vw;
    }

    .single .divider {
        width: 3vw;
    }

    .divider-line {
        width: 0.5vh;
        background-color: #252525;
    }

    .time-column {
        text-align: right;
    }

    .center-column {
        text-align: center;
        padding: 0 1vw 0 1vw;
    }

    .important-cell {
        color: var(--base-color);
    }
</style>
